module.exports = __webpack_public_path__ + "static/media/img_process1.88d1445b.png";